import { useEffect } from "react";

export default function Spreadsheet(){
    useEffect(()=>{
        window.location.reload();
    },[])

    return(<></>)
}